import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import useSWR, { type SWRConfiguration } from "swr";

type GetActiveLabelsResponse = {
  labels: Record<string, string[]>;
};

const fetcher = (url: string) => {
  return romanApi.get<GetActiveLabelsResponse>(url);
};

export const useGetActiveLabels = (swrOptions?: SWRConfiguration<GetActiveLabelsResponse, RomanApiError>) => {
  const { data, error, isLoading } = useSWR("/prediction-market/labels", fetcher, swrOptions);

  return {
    activeLabels: data?.labels ?? [],
    isLoading,
    error,
  };
};
